export const baseUrl='https://api.themoviedb.org/3';
export const API_KEY='29d093823540376c11634f8406d4f40a';
export const imageUrl="https://image.tmdb.org/t/p/original";